import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import Input from '../components/Input'
import { addRole } from '../actions/roleActions'
import { ADD_ROLE_RESET } from '../constants/roleConstants'

// ─── Reusable check ───────────────────────────────────────────────
function Check({ label, checked, onChange }) {
  return (
    <label className="flex items-center gap-2 cursor-pointer select-none">
      <input
        type="checkbox"
        checked={!!checked}
        onChange={e => onChange(e.target.checked)}
        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 h-4 w-4"
      />
      <span className="text-sm text-gray-700">{label}</span>
    </label>
  )
}

function Section({ title, children, allChecked, onToggleAll }) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-3 pb-2 border-b border-gray-200">
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider">{title}</h3>
        {onToggleAll && (
          <label className="flex items-center gap-2 cursor-pointer select-none">
            <span className="text-xs font-medium text-gray-500">Select All</span>
            <input
              type="checkbox"
              checked={!!allChecked}
              onChange={e => onToggleAll(e.target.checked)}
              className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 h-4 w-4"
            />
          </label>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">{children}</div>
    </div>
  )
}

const AddRole = () => {
  const dispatch = useDispatch()

  const [name, setName] = useState('')

  const [usersView, setUsersView] = useState(false)
  const [usersAdd, setUsersAdd] = useState(false)
  const [usersUpdate, setUsersUpdate] = useState(false)
  const [usersBulkSelect, setUsersBulkSelect] = useState(false)
  const [rejoinUsers, setRejoinUsers] = useState(false)
  const [forceLogoutUsers, setForceLogoutUsers] = useState(false)
  const [resetUserRateLimit, setResetUserRateLimit] = useState(false)
  const [resignedUsers, setResignedUsers] = useState(false)
  const [rolesView, setRolesView] = useState(false)
  const [rolesAdd, setRolesAdd] = useState(false)
  const [rolesUpdate, setRolesUpdate] = useState(false)
  const [rolesDelete, setRolesDelete] = useState(false)
  const [auditLogView, setAuditLogView] = useState(false)
  const [appAccess, setAppAccess] = useState(false)
  const [webAccess, setWebAccess] = useState(false)
  const [settings, setSettings] = useState(false)
  const [reports, setReports] = useState(false)
  const [dashboard, setDashboard] = useState(false)
  const [loanEnquiriesView, setLoanEnquiriesView] = useState(false)
  const [loanEnquiriesEdit, setLoanEnquiriesEdit] = useState(false)
  const [loanEnquiriesDelete, setLoanEnquiriesDelete] = useState(false)
  const [loanEnquiriesSendBack, setLoanEnquiriesSendBack] = useState(false)
  const [loanEnquiriesTransferMerchant, setLoanEnquiriesTransferMerchant] = useState(false)
  const [paymentView, setPaymentView] = useState(false)
  const [sendBackEnquiriesView, setSendBackEnquiriesView] = useState(false)
  const [sendBackEnquiriesEdit, setSendBackEnquiriesEdit] = useState(false)
  const [sendBackEnquiriesDelete, setSendBackEnquiriesDelete] = useState(false)
  const [sendBackEnquiriesRestore, setSendBackEnquiriesRestore] = useState(false)
  const [sendBackEnquiriesWelcomeCall, setSendBackEnquiriesWelcomeCall] = useState(false)
  const [merchantPageView, setMerchantPageView] = useState(false)
  const [merchantView, setMerchantView] = useState(false)
  const [merchantAdd, setMerchantAdd] = useState(false)
  const [merchantEdit, setMerchantEdit] = useState(false)
  const [merchantDelete, setMerchantDelete] = useState(false)
  const [merchantToggle, setMerchantToggle] = useState(false)
  const [productMasterView, setProductMasterView] = useState(false)
  const [productMasterAdd, setProductMasterAdd] = useState(false)
  const [productMasterUpdate, setProductMasterUpdate] = useState(false)
  const [productMasterDelete, setProductMasterDelete] = useState(false)
  const [qrView, setQrView] = useState(false)
  const [formView, setFormView] = useState(false)
  const [qrPoolView, setQrPoolView] = useState(false)
  const [qrPoolCreate, setQrPoolCreate] = useState(false)
  const [qrPoolUpdate, setQrPoolUpdate] = useState(false)
  const [qrPoolDelete, setQrPoolDelete] = useState(false)

  // Caller List
  const [callerListView, setCallerListView] = useState(false)
  const [callerListAdd, setCallerListAdd] = useState(false)
  const [callerListEdit, setCallerListEdit] = useState(false)
  const [callerListDelete, setCallerListDelete] = useState(false)
  // Prospects
  const [prospectsView, setProspectsView] = useState(false)
  // Daily Call Report
  const [dailyCallReportView, setDailyCallReportView] = useState(false)
  const [dailyCallReportAdd, setDailyCallReportAdd] = useState(false)
  const [dailyCallReportEdit, setDailyCallReportEdit] = useState(false)
  const [dailyCallReportDelete, setDailyCallReportDelete] = useState(false)

  // Agent Program
  const [agentProgramView, setAgentProgramView] = useState(false)
  const [agentProgramViewAll, setAgentProgramViewAll] = useState(false)
  const [agentProgramLeadSubmit, setAgentProgramLeadSubmit] = useState(false)
  const [agentProgramMarkGenuine, setAgentProgramMarkGenuine] = useState(false)
  const [agentProgramMarkAccepted, setAgentProgramMarkAccepted] = useState(false)
  const [agentProgramMarkDisbursed, setAgentProgramMarkDisbursed] = useState(false)
  const [agentProgramMarkCommissionReceived, setAgentProgramMarkCommissionReceived] = useState(false)
  const [agentProgramClawback, setAgentProgramClawback] = useState(false)
  const [agentProgramConfigView, setAgentProgramConfigView] = useState(false)
  const [agentProgramConfigEdit, setAgentProgramConfigEdit] = useState(false)
  const [agentProgramKycView, setAgentProgramKycView] = useState(false)
  const [agentProgramKycVerify, setAgentProgramKycVerify] = useState(false)
  const [agentProgramPayoutRelease, setAgentProgramPayoutRelease] = useState(false)
  const [agentProgramRequestPayout, setAgentProgramRequestPayout] = useState(false)
  const [agentProgramReset, setAgentProgramReset] = useState(false)

  const { userInfo } = useSelector(state => state.userLogin)
  const { loadingAddRoleInfo, errorAddRoleInfo, addRoleData } = useSelector(state => state.addRoleInfo)

  useEffect(() => {
    dispatch({ type: ADD_ROLE_RESET })
    if (addRoleData) {
      toast('Role added successfully', { type: 'success', hideProgressBar: true, autoClose: 2000 })
    } else if (errorAddRoleInfo) {
      toast(errorAddRoleInfo, { type: 'error', hideProgressBar: true, autoClose: 2000 })
    }
  }, [addRoleData, errorAddRoleInfo])

  const addRoleHandler = () => {
    if (!name) { toast('Name is mandatory', { type: 'error', hideProgressBar: true, autoClose: 2000 }); return }
    dispatch(addRole(
      name,
      usersView, usersAdd, usersUpdate, usersBulkSelect,
      rejoinUsers,
      forceLogoutUsers, resetUserRateLimit,
      resignedUsers, rolesView, rolesAdd, rolesUpdate, rolesDelete, auditLogView,
      appAccess, webAccess, settings, reports,
      // pincodes,
      dashboard,
      loanEnquiriesView, loanEnquiriesEdit,
      loanEnquiriesDelete, loanEnquiriesSendBack, loanEnquiriesTransferMerchant, paymentView,
      sendBackEnquiriesView, sendBackEnquiriesEdit, sendBackEnquiriesDelete, sendBackEnquiriesRestore, sendBackEnquiriesWelcomeCall,
      merchantPageView, merchantView, merchantAdd, merchantEdit, merchantDelete, merchantToggle,
      productMasterView, productMasterAdd, productMasterUpdate, productMasterDelete,
      qrView, formView, qrPoolView, qrPoolCreate, qrPoolUpdate, qrPoolDelete,
      callerListView, callerListAdd, callerListEdit, callerListDelete,
      prospectsView,
      dailyCallReportView, dailyCallReportAdd, dailyCallReportEdit, dailyCallReportDelete,
      agentProgramView, agentProgramViewAll, agentProgramLeadSubmit,
      agentProgramMarkGenuine, agentProgramMarkAccepted, agentProgramMarkDisbursed,
      agentProgramMarkCommissionReceived, agentProgramClawback,
      agentProgramConfigView, agentProgramConfigEdit,
      agentProgramKycView, agentProgramKycVerify, agentProgramPayoutRelease, agentProgramRequestPayout, agentProgramReset
    ))
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-semibold text-gray-800">Add Role</h1>
        </div>

      <div className="bg-white rounded-xl shadow-sm p-6">
        <div className="mb-8">
          <label className="block text-sm font-medium text-gray-700 mb-1">Role Name *</label>
          <Input name="Name" value={name} onChange={e => setName(e.target.value)} />
        </div>



        <Section
          title="Users"
          allChecked={usersView && usersAdd && usersUpdate && rejoinUsers && forceLogoutUsers && resetUserRateLimit && resignedUsers}
          onToggleAll={v => { setUsersView(v); setUsersAdd(v); setUsersUpdate(v); setRejoinUsers(v); setForceLogoutUsers(v); setResetUserRateLimit(v); setResignedUsers(v) }}
        >
          <Check label="View Users" checked={usersView} onChange={setUsersView} />
          <Check label="Add Users" checked={usersAdd} onChange={setUsersAdd} />
          <Check label="Update Users" checked={usersUpdate} onChange={setUsersUpdate} />
          <Check label="Bulk Select Users" checked={usersBulkSelect} onChange={setUsersBulkSelect} />
          <Check label="Rejoin Users" checked={rejoinUsers} onChange={setRejoinUsers} />
          <Check label="Force Logout Users" checked={forceLogoutUsers} onChange={setForceLogoutUsers} />
          <Check label="Reset User Rate Limit" checked={resetUserRateLimit} onChange={setResetUserRateLimit} />
          <Check label="Resigned Users" checked={resignedUsers} onChange={setResignedUsers} />
        </Section>

        <Section
          title="Roles"
          allChecked={rolesView && rolesAdd && rolesUpdate && rolesDelete}
          onToggleAll={v => { setRolesView(v); setRolesAdd(v); setRolesUpdate(v); setRolesDelete(v) }}
        >
          <Check label="View Roles" checked={rolesView} onChange={setRolesView} />
          <Check label="Add Roles" checked={rolesAdd} onChange={setRolesAdd} />
          <Check label="Update Roles" checked={rolesUpdate} onChange={setRolesUpdate} />
          <Check label="Delete Roles" checked={rolesDelete} onChange={setRolesDelete} />
        </Section>

        <Section
          title="Audit Log"
          allChecked={auditLogView}
          onToggleAll={v => setAuditLogView(v)}
        >
          <Check label="View Audit Log" checked={auditLogView} onChange={setAuditLogView} />
        </Section>



        <Section
          title="Login Access"
          allChecked={appAccess && webAccess}
          onToggleAll={v => { setAppAccess(v); setWebAccess(v) }}
        >
          <Check label="App Access" checked={appAccess} onChange={setAppAccess} />
          <Check label="Web Access" checked={webAccess} onChange={setWebAccess} />
        </Section>

        <Section
          title="Settings"
          allChecked={settings && dashboard}
          onToggleAll={v => { setSettings(v); setDashboard(v) }}
        >
          <Check label="Settings" checked={settings} onChange={setSettings} />

          <Check label="Dashboard" checked={dashboard} onChange={setDashboard} />
        </Section>

        <Section
          title="Onboard Merchant"
          allChecked={merchantPageView && merchantView && merchantAdd && merchantEdit && merchantDelete && merchantToggle}
          onToggleAll={v => { setMerchantPageView(v); setMerchantView(v); setMerchantAdd(v); setMerchantEdit(v); setMerchantDelete(v); setMerchantToggle(v) }}
        >
          <Check label="Page View" checked={merchantPageView} onChange={setMerchantPageView} />
          <Check label="View Merchant" checked={merchantView} onChange={setMerchantView} />
          <Check label="Add Merchant" checked={merchantAdd} onChange={setMerchantAdd} />
          <Check label="Edit Merchant" checked={merchantEdit} onChange={setMerchantEdit} />
          <Check label="Delete Merchant" checked={merchantDelete} onChange={setMerchantDelete} />
          <Check label="Active Toggle" checked={merchantToggle} onChange={setMerchantToggle} />
        </Section>

        <Section
          title="Merchant Permissions"
          allChecked={loanEnquiriesView && loanEnquiriesEdit && loanEnquiriesDelete && loanEnquiriesSendBack && loanEnquiriesTransferMerchant && qrView && formView}
          onToggleAll={v => { setLoanEnquiriesView(v); setLoanEnquiriesEdit(v); setLoanEnquiriesDelete(v); setLoanEnquiriesSendBack(v); setLoanEnquiriesTransferMerchant(v); setQrView(v); setFormView(v) }}
        >
          <Check label="Loan Enquiries – View" checked={loanEnquiriesView} onChange={setLoanEnquiriesView} />
          <Check label="Loan Enquiries – Edit" checked={loanEnquiriesEdit} onChange={setLoanEnquiriesEdit} />
          <Check label="Loan Enquiries – Delete" checked={loanEnquiriesDelete} onChange={setLoanEnquiriesDelete} />
          <Check label="Loan Enquiries – Send Back" checked={loanEnquiriesSendBack} onChange={setLoanEnquiriesSendBack} />
          <Check label="Loan Enquiries – Transfer Merchant" checked={loanEnquiriesTransferMerchant} onChange={setLoanEnquiriesTransferMerchant} />
          <Check label="QR – View" checked={qrView} onChange={setQrView} />
          <Check label="Form – View" checked={formView} onChange={setFormView} />
        </Section>

        <Section
          title="Payments"
          allChecked={paymentView}
          onToggleAll={v => setPaymentView(v)}
        >
          <Check label="Payments – Page View" checked={paymentView} onChange={setPaymentView} />
        </Section>

        <Section
          title="Send Back Enquiries"
          allChecked={sendBackEnquiriesView && sendBackEnquiriesEdit && sendBackEnquiriesDelete && sendBackEnquiriesRestore && sendBackEnquiriesWelcomeCall}
          onToggleAll={v => { setSendBackEnquiriesView(v); setSendBackEnquiriesEdit(v); setSendBackEnquiriesDelete(v); setSendBackEnquiriesRestore(v); setSendBackEnquiriesWelcomeCall(v) }}
        >
          <Check label="Send Back Enquiries – View" checked={sendBackEnquiriesView} onChange={setSendBackEnquiriesView} />
          <Check label="Send Back Enquiries – Edit" checked={sendBackEnquiriesEdit} onChange={setSendBackEnquiriesEdit} />
          <Check label="Send Back Enquiries – Delete" checked={sendBackEnquiriesDelete} onChange={setSendBackEnquiriesDelete} />
          <Check label="Send Back Enquiries – Restore" checked={sendBackEnquiriesRestore} onChange={setSendBackEnquiriesRestore} />
          <Check label="Send Back Enquiries – Welcome Call/Message" checked={sendBackEnquiriesWelcomeCall} onChange={setSendBackEnquiriesWelcomeCall} />
        </Section>

        <Section
          title="Product Master"
          allChecked={productMasterView && productMasterAdd && productMasterUpdate && productMasterDelete}
          onToggleAll={v => { setProductMasterView(v); setProductMasterAdd(v); setProductMasterUpdate(v); setProductMasterDelete(v) }}
        >
          <Check label="Product Master – View" checked={productMasterView} onChange={setProductMasterView} />
          <Check label="Product Master – Add" checked={productMasterAdd} onChange={setProductMasterAdd} />
          <Check label="Product Master – Update" checked={productMasterUpdate} onChange={setProductMasterUpdate} />
          <Check label="Product Master – Delete" checked={productMasterDelete} onChange={setProductMasterDelete} />
        </Section>

        <Section
          title="QR Pool"
          allChecked={qrPoolView && qrPoolCreate && qrPoolUpdate && qrPoolDelete}
          onToggleAll={v => { setQrPoolView(v); setQrPoolCreate(v); setQrPoolUpdate(v); setQrPoolDelete(v) }}
        >
          <Check label="QR Pool – View" checked={qrPoolView} onChange={setQrPoolView} />
          <Check label="QR Pool – Create" checked={qrPoolCreate} onChange={setQrPoolCreate} />
          <Check label="QR Pool – Update" checked={qrPoolUpdate} onChange={setQrPoolUpdate} />
          <Check label="QR Pool – Delete" checked={qrPoolDelete} onChange={setQrPoolDelete} />
        </Section>

        <Section title="Caller List">
          <Check label="Caller List – View" checked={callerListView} onChange={setCallerListView} />
          <Check label="Caller List – Add" checked={callerListAdd} onChange={setCallerListAdd} />
          <Check label="Caller List – Edit" checked={callerListEdit} onChange={setCallerListEdit} />
          <Check label="Caller List – Delete" checked={callerListDelete} onChange={setCallerListDelete} />
        </Section>

        <Section title="Prospects">
          <Check label="Prospects – View" checked={prospectsView} onChange={setProspectsView} />
        </Section>

        <Section title="Daily Call Report">
          <Check label="Daily Call Report – View" checked={dailyCallReportView} onChange={setDailyCallReportView} />
          <Check label="Daily Call Report – Add" checked={dailyCallReportAdd} onChange={setDailyCallReportAdd} />
          <Check label="Daily Call Report – Edit" checked={dailyCallReportEdit} onChange={setDailyCallReportEdit} />
          <Check label="Daily Call Report – Delete" checked={dailyCallReportDelete} onChange={setDailyCallReportDelete} />
        </Section>

        <Section title="Agent Program">
          <Check label="Agent Program – View (own)" checked={agentProgramView} onChange={setAgentProgramView} />
          <Check label="Agent Program – View All Agents" checked={agentProgramViewAll} onChange={setAgentProgramViewAll} />
          <Check label="Agent Program – Submit Lead" checked={agentProgramLeadSubmit} onChange={setAgentProgramLeadSubmit} />
          <Check label="Agent Program – Mark Genuine" checked={agentProgramMarkGenuine} onChange={setAgentProgramMarkGenuine} />
          <Check label="Agent Program – Accept Application" checked={agentProgramMarkAccepted} onChange={setAgentProgramMarkAccepted} />
          <Check label="Agent Program – Mark Disbursed" checked={agentProgramMarkDisbursed} onChange={setAgentProgramMarkDisbursed} />
          <Check label="Agent Program – Record Commission Received" checked={agentProgramMarkCommissionReceived} onChange={setAgentProgramMarkCommissionReceived} />
          <Check label="Agent Program – Clawback" checked={agentProgramClawback} onChange={setAgentProgramClawback} />
          <Check label="Agent Program – Config View" checked={agentProgramConfigView} onChange={setAgentProgramConfigView} />
          <Check label="Agent Program – Config Edit" checked={agentProgramConfigEdit} onChange={setAgentProgramConfigEdit} />
          <Check label="Agent Program – KYC View" checked={agentProgramKycView} onChange={setAgentProgramKycView} />
          <Check label="Agent Program – KYC Verify" checked={agentProgramKycVerify} onChange={setAgentProgramKycVerify} />
          <Check label="Agent Program – Release Payout" checked={agentProgramPayoutRelease} onChange={setAgentProgramPayoutRelease} />
          <Check label="Agent Program – Request Payout (agent self-service)" checked={agentProgramRequestPayout} onChange={setAgentProgramRequestPayout} />
          <Check label="Agent Program – Reset Agent (full wipe)" checked={agentProgramReset} onChange={setAgentProgramReset} />
        </Section>

        <button
          type="button"
          onClick={addRoleHandler}
          disabled={loadingAddRoleInfo}
          className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white text-sm font-medium px-6 py-2.5 rounded-lg transition-colors mt-2"
        >
          {loadingAddRoleInfo ? 'Adding…' : 'Add Role'}
        </button>
      </div>
      </div>
    </div>
  )
}

export default AddRole
